/* eslint-disable quotes */

const inbound_settings = {
  tabs: {
    reputation: 'アンチスパム/アンチウイルス',
    custom_rbls: 'カスタム RBL',
    rate_control: 'レートコントロール',
    ip_policies: 'IP アドレスポリシー',
    regional_policies: '地域政策',
    recipient_policies: '受信者ポリシー',
    sender_policies: '送信者ポリシー',
    sender_auth: '送信者認証',
    content_policies: 'コンテンツポリシー',
    anti_phishing: 'フィッシング対策',
    machine_learning: '機械学習'
  },
  save: '変更を保存',
  cancel: '[キャンセル]',
  bulk_edit: '一括編集',
  reputation: {
    title: 'アンチスパム/アンチウイルス',
    block: '[ブロック]',
    quarantine: '検疫',
    off: '[オフ]',
    yes: 'はい',
    no: 'いいえ',
    use_reputation_block_list: 'バラクーダ評価ブロックリストを使用する',
    scan_email_or_viruses: 'Eメールのウイルススキャン',
    use_real_time: 'バラクーダリアルタイムシステムを使用',
    send_to_barracuda: '不審なメッセージコンテンツをバラクーダセントラルに送信して分析してもらう',
    enable_cloudscan: 'クラウドスキャンを有効にする',
    cloudscan_scoring: 'クラウドスキャンスコアリング',
    cloudscan_scoring_description:
      'CloudScan がスキャンするメッセージのスコア値を設定します。スコアは 1 から 10 まで設定できます。スコアを 0 に設定すると CloudScan スコアリングが無効になります。',
    action: 'アクション',
    score: 'スコア',
    enabled: '有効',
    category_name: 'カテゴリ名',
    description: '[説明]',
    recommended: 'おすすめ',
    allow: '許可',
    bulk_email_detection: 'メールの一括検出',
    bulk_email_exemptions: 'バルクメールの免除',
    brts_exemptions: 'Barracuda リアルタイムシステム除外',
    brbl_exemptions: 'Barracuda 評価ブロックリスト除外',
    email_categorization: 'メール分類',
    emailcat_corporate_name: '企業電子メール',
    emailcat_corporate_description:
      'エクスチェンジサーバーから送信された電子メール。一般的な企業コミュニケーション。マーケティングニュースレターはありません。',
    emailcat_transactional_name: 'トランザクション電子メール',
    emailcat_transactional_description:
      '注文確認、請求書、銀行取引明細書、請求書、毎月の請求書、UPS出荷通知、提供されたサービスや取引が行われた場所に関する調査',
    emailcat_marketing_name: 'マーケティング資料とニュースレター',
    emailcat_marketing_description: '常時接触（両レベル）。など...',
    emailcat_listserver_name: 'メーリングリスト',
    emailcat_listserver_description:
      'メーリングリスト、ニュースグループ、および Google や Yahoo! などのサブスクリプションベースのサービスからのメールグループ。',
    emailcat_socialmedia_name: 'ソーシャル・メディア',
    emailcat_socialmedia_description:
      'FacebookやLinkedInなどのソーシャルメディアサイトからの通知やその他の電子メール。',
    email_domain: 'メール/ドメイン',
    sender: '送信者',
    recipient: '受信者',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    confirm_removal: '削除を確認しますか?',
    error: {
      empty_domain: 'ドメイン名を指定してください。',
      invalid_domain: '入力されたドメイン名は無効です。',
      duplicate_value: '値が重複しています:{item}',
      invalid_email_domain: '入力されたドメイン/Eメールは有効ではありません。',
      wildcard_domain: 'ワイルドカード・ドメインはサポートされていません。'
    }
  },
  custom_rbls: {
    title: 'カスタム RBL',
    zone: 'ゾーン',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    duplicate_value: 'ドメインは既に存在しています。',
    specify_domain: 'ドメイン名を指定してください。',
    invalid_domain: '入力されたドメイン名は無効です。'
  },
  rate_control: {
    title: 'レートコントロール',
    rate_control_exemptions: 'レートコントロール免除',
    internal_rate_control: '内部レートコントロール',
    exempt_rate_control: 'このアカウントのドメイン間の免除率管理',
    rate_control: 'レートコントロール',
    yes: 'はい',
    no: 'いいえ',
    maximum_messages: '30 分あたりの送信者 IP アドレスあたりの最大メッセージ数',
    default_value: 'デフォルト値:1000'
  },
  ip_policies: {
    title: 'IP アドレスポリシー',
    ip_blocking_exemption: 'IP ブロッキング/免除',
    trusted_forwarders: '信頼できるフォワーダー'
  },
  regional_policies: {
    title: '地域政策',
    sender_policies: '送信者ポリシー',
    content_policies: 'コンテンツポリシー',
    geo_policies: 'GeoIP ポリシー',
    language_policies: '言語ポリシー',
    geo_policies_sender_exmpt_name: 'メールアドレス/ドメイン別の GeoIP 免除',
    geo_policies_exempt_address: '送信者 IP アドレスによる GeoIP 適用除外',
    email_domain: 'Eメールアドレス/ドメイン',
    country: 'カントリー',
    language: '言語',
    policy: 'ポリシー',
    comment: '[コメント]',
    actions: '[アクション]',
    block: '[ブロック]',
    quarantine: '検疫',
    add: '追加',
    remove: '[削除]',
    duplicate_value: '重複したエントリが存在します。',
    arb: 'アラビア語',
    cmn: '中国語',
    deu: 'ドイツ人',
    ell: 'ギリシャ語',
    heb: 'ヘブライ語',
    jpn: '日本人',
    kor: '韓国語',
    rus: 'ロシア人',
    tha: 'タイ語',
    tur: 'トルコ語',
    vie: 'ベトナム語',
    invalid_email: '有効なEメールアドレスを入力してください。',
    language_policy_exemptions: '言語ポリシー免除'
  },
  recipient_policies: {
    title: '受信者ポリシー',
    default_policy_description: 'すべてのユーザーのデフォルトポリシー:',
    recipient: '受信者',
    policy: 'ポリシー',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    scan: 'スキャン',
    exempt: '免除',
    save: '[保存]',
    invalid_email: '有効なEメールアドレスを入力してください。',
    duplicate_value: '重複したエントリが存在します。'
  },
  sender_policies: {
    title: '送信者ポリシー',
    sender: '送信者',
    policy: 'ポリシー',
    modified: '修正済み',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    block: '[ブロック]',
    exempt: '免除',
    quarantine: '検疫',
    invalid_email: '有効なEメールアドレスを入力してください。',
    duplicate_value: '重複したエントリが存在します。',
    search_placeholder: '送信者またはコメントを検索'
  },
  sender_auth: {
    title: '送信者認証',
    bulk_edit: '一括編集',
    dmarc_dkim_spf_header: 'Dマーク、スリム、SPF',
    yes: 'はい',
    no: 'いいえ',
    block: '[ブロック]',
    quarantine: '検疫',
    off: '[オフ]',
    dmarc_label: 'ドメインベースのメッセージ認証 (DMARC) を使用する',
    dmarc_note:
      '注:DMARCレコードと「隔離」または「拒否」のポリシーを持つ送信者は、以下のDKIMとSPFの設定よりも優先されます。',
    dmarc_table: 'DMARC 免除',
    dkim_label: 'ドメインキー識別メール (DKIM) アクション',
    dkim_table: 'DKIM 免除',
    spf_label: '送信者ポリシーフレームワーク (SPF) チェックを有効にする',
    spf_exempt: 'IP アドレスによる SPF 免除',
    spf_domain_exempt: 'ドメイン別の SPF 免除',
    hard_fail: 'ハードフェイル',
    soft_fail: 'ソフトフェイル',
    spf_missing_label: 'SPF レコードがない場合はブロック',
    spf_missing_table: 'SPF 免除項目がない',
    spf_missing_domain_exempt: 'ドメイン別の SPF 免除項目がない',
    ptr_header: 'PTR レコード',
    ptr_label: 'PTR レコードがない場合はブロック',
    ptr_table: 'PTR 免除項目がない'
  },
  content_policies: {
    title: 'コンテンツポリシー',
    attachment_filter: '添付ファイルフィルター',
    filter_type: 'フィルタータイプ',
    pattern: 'パターン',
    check_archives: 'アーカイブをチェック',
    action: 'アクション',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    no: 'いいえ',
    yes: 'はい',
    scan: 'スキャン',
    do_not_scan: 'スキャンしない',
    block: '[ブロック]',
    ignore: '無視',
    allow: '許可',
    quarantine: '検疫',
    filename: '[ファイル名]',
    mime: 'マイムタイプ',
    message_content_filter: 'メッセージコンテンツフィルター',
    subject: '件名',
    headers: 'ヘッダー',
    body: 'ボディ',
    attachments: '添付ファイル',
    sender: '送信者',
    recipient: '受信者',
    match: 'マッチ',
    one_match_filter: '少なくとも 1 つのマッチフィルターを選択する必要があります。',
    duplicate_value: '重複したエントリが存在します。',
    empty_pattern: 'パターンを指定してください。',
    archive_filtering: 'パスワードで保護されたアーカイブフィルタ:',
    msoffice_filtering: 'パスワードで保護されたマイクロソフトオフィス文書:',
    pdf_filtering: 'パスワードで保護された PDF フィルタリング:',
    save: '[保存]',
    missing_pattern: 'フィルタリングパターンが見つからない',
    invalid_regex_warning: 'パターンに無効な正規表現構文が含まれています'
  },
  anti_phishing: {
    title: 'フィッシング対策',
    bafi_label: '不正防止インテリジェンス',
    sender_label: '外部送信者警告',
    block: '[ブロック]',
    quarantine: '検疫',
    ignore: '無視',
    defer: '延期',
    off: '[オフ]',
    yes: 'はい',
    no: 'いいえ',
    on: 'オン',
    intent: '意図',
    intent_label: '意図分析',
    content_label: 'コンテンツインテント',
    intent_realtime_label: 'リアルタイムインテント分析を使用する',
    link_label: 'リンク保護',
    typosquat_label: 'タイポスクワッティング対策',
    intent_domain_table: 'インテントドメインポリシー',
    domain: '[ドメイン名]',
    policy: 'ポリシー',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    duplicate_value: 'ドメイン {domain} はすでに存在しています。',
    specify_domain: 'ドメイン名を指定してください。',
    invalid_domain: '入力されたドメイン名は無効です。',
    email_banners: 'メール警告バナー',
    warning_banner_exemptions: 'メール警告バナー免除',
    antifraud_exemptions: '不正防止インテリジェンス免除',
    insert_email_banners: 'メール警告バナーの挿入',
    testing_mode: 'テストモード',
    email_banners_testing_mode_text:
      'Eメール警告バナーがどのように機能するのかわからない場合は、テストモードをご利用ください。テストモードを使用して、一部のユーザーでこの機能をお試しください。',
    testing_mode_enable: '次のユーザーメールに対して有効にする',
    testing_mode_placeholder: '例:hello@demo.com、abc@demo.com',
    duplicate_email: 'メールが重複しています:{email}',
    invalid_email: 'Eメールが無効です:{email}',
    blank_email: 'Eメールアドレスを入力してください',
    beta_version: 'ベータ版'
  },
  machine_learning: {
    title: '機械学習',
    machine_learning_exempt: 'メールアドレス/ドメインによる機械学習免除',
    email_domain: 'メール/ドメイン',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    invalid_email_domain: '入力されたドメイン/Eメールは有効ではありません。',
    duplicate_value: 'ドメインは既に存在しています。',
    specify_domain: 'ドメイン名を指定してください。',
    invalid_domain: '入力されたドメイン名は無効です。',
    subscription_bomb_detection: 'サブスクリプションボム検出',
    subscription_bomb_action_block: 'ブロック',
    subscription_bomb_action_quarantine: '隔離',
    subscription_bomb_description: 'サブスクリプションボム攻撃を検出して軽減します。',
    subscription_bomb_learn_more: '詳細'
  }
}

/* eslint-enable quotes */

export default inbound_settings
